export const GALLERY_MODAL_STATES = {
  maxCountError: 'maxCountError',
  delete: 'delete',
  viewPhoto: 'viewPhoto',
};
